<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-add`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.99902 2C8.36622 2.00008 8.66406 2.29782 8.66406 2.66504V7.33398H13.333C13.7001 7.3341 13.998 7.63188 13.998 7.99902C13.998 8.36622 13.7002 8.66395 13.333 8.66406H8.66406V13.333C8.66392 13.7001 8.36613 13.998 7.99902 13.998C7.63184 13.998 7.33413 13.7002 7.33398 13.333V8.66406H2.66504C2.29777 8.66406 2 8.36629 2 7.99902C2.00007 7.63181 2.29781 7.33398 2.66504 7.33398H7.33398V2.66504C7.33398 2.29777 7.63175 2 7.99902 2Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineAdd',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
